import { emptyExistingAdUnitAction } from "../actions";
import { takeEvery, all, put } from "redux-saga/effects";
import { campaignCreativesForm } from "../../campaign";

function* emptyExistingAdUnit() {
    yield put(campaignCreativesForm.actions.fieldEdit("adUnitId", ""));
}

export function* emptyExistingAdUnitSaga() {
    yield all([takeEvery(emptyExistingAdUnitAction.type, emptyExistingAdUnit)]);
}
